export default __webpack_public_path__ + "img/waveedge-capabilities-grid.114e83a4.png";